export default __webpack_public_path__ + "static/media/ai-design-studio-logo.ff6914a0.png";